<template>
  <div>
    <div class="app-container-v2 table-container-v2">
      <div class="title-box">
        <el-form inline label-suffix=":">
          <el-form-item label="账单信息">({{ this.$route.query.billId }})</el-form-item>
          <el-form-item label="客户名称">({{ this.$route.query.cusName }})</el-form-item>
        </el-form>
        <div class="title-right">
<!--          <el-checkbox v-model="radio" @change="changeRadioAction">{{ checkBoxMsg }}</el-checkbox>-->
          <el-button plain class="button-v2" @click="customHeaderModalShow = true">{{
              $t('displayItemConfiguration')
            }}
          </el-button>
<!--          <el-button type="primary" class="button-v2" :loading="submitLoading" @click="handleExport">{{
              $t('export')
            }}
          </el-button>-->
          <el-button type="primary" class="button-v2" @click="exportTable">导出</el-button>
          <el-button plain class="button-v2" @click="$back">返回列表</el-button>
        </div>
<!--        <div class="divButtonRigth">
          &lt;!&ndash;                <el-button type="primary" @click="openCustomHeader">自定义表头</el-button>&ndash;&gt;
          <el-button type="primary" @click="exportTable">导出</el-button>
          <el-button plain class="button-v2" @click="$back">返回列表</el-button>
        </div>-->
      </div>
    </div>

    <bigTable
      ref="bigEdit"
      :loading.sync="loading"
      :names.sync="showColumn"
      :datas.sync="bigDatas"
      refname="bigTable"
      :amountColumns="amountColumns"
    >
    </bigTable>

    <el-dialog
      class="modal-v2 has-padding"
      width="800px"
      v-dialogDrag
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="$t('displayItemConfiguration')"
      :visible.sync="customHeaderModalShow"
      append-to-body
    >
      <customHeader :header-list.sync="headerList" :modeType = "modeType" report-type="成本中心汇总"></customHeader>
      <div slot="footer" class="w100 flex jbetween acenter">
        <el-button plain class="button-v2" @click="customHeaderModalShow = false">{{ $t('cancel') }}</el-button>
        <el-button type="primary" class="button-v2" :loading="submitLoading" @click="saveCustomHeader">{{
            $t('save')
          }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import bigTable from "@/views/wage/pay-notice/dataImportTable"
import * as api from '@/api/v2/service-process/order'
import {mapGetters} from 'vuex';
import customHeader from '@/components/v2/custom-cost-header'
import {updataCustCostFormsHeaderInfo, costFormsListHeader} from "@/api/wage/pay";

export default {
  name: "CostForm",
  components: {
    bigTable,
    customHeader,
  },
  computed: {
    ...mapGetters(['dicts', 'memberInfo', 'pms']),
    amountColumns() {
      return this.showColumn
        .filter(col => col.valueType == '2') // 宽松比较
        .map(col => col.field)
        .filter(field => field); // 去除 undefined
    }
  },
  data() {
    return {
      tablePar: {
        cusId: this.$route.query.cusId,
        modeType: "costForms",
        header: []
      },
      headerList: [],
      dialogHeaderVisible: false,
      updateDimension: false,
      isMergeBill: '',
      isCusGroup: '',
      cusId: '',
      dimension: 'biz_salary_detail.COST_CENTER',
      dimensionList: [],
      checked: false,
      // 遮罩
      loading: false,
      costCenterList: [],
      allColumn: [], //所有表头
      showColumn: [], //显示表头
      copyDatas: [],
      bigDatas: [],

      hiddenColumns: [],//需要隐藏的列
      expHiddenColumns: [],//需要隐藏的列
      sumListCode: [],//需要合计的列
      radio: false,
      checkBoxMsg: '隐藏空列',
      render: false,
      wageMonthRange: [],
      isSelectChange: false,
      queryParams: {
        startDate: undefined,
        endDate: undefined,
        idCards: [],
        costCenters: [],
        taxTypes: [],
        // wageMonths: [],
        cuswIds: [],
        isHidden: false,
        page: 1,
        limit: 20,
        total: 0
      },
      limitCustom: 1,
      dictMap: {},
      dictData: {
        emp: [],
        costCenter: [],
        taxType: []
      },
      columns: [],
      tableData: [],
      submitLoading: false,
      customHeaderModalShow: false,
      modeType: 'costForms'
    }
  },
  created() {
    this.cusId = this.$route.query.cusId
    this.isMergeBill = this.$route.query.isMergeBill
    this.isCusGroup = this.$route.query.isCusGroup
    // debugger
    // this.getDimensionList()
    this._getimportHeader();
  },

  methods: {
    changeDimension() {
      this.updateDimension = true
      this._getCostFormsList()
      this.showColumn = this.filterIsShowHeaders(this.showColumn)
    },
    getDimensionList() {
      let dict = JSON.parse(JSON.stringify(this.dicts.codeList['4030']))
      for (let i = 0; i < dict.length; i++) {
        let s = dict[i].codeItemCode
        let str = s.substring(s.lastIndexOf(".") + 1, s.length);
        str = str.toLowerCase()
        let upperCase = false;
        let codeItemEnName = ''
        for (let j = 0; j < str.length; j++) {
          let c = str.substring(j, j + 1)
          if (c == '_') {
            upperCase = true;
          } else if (upperCase) {
            codeItemEnName = codeItemEnName + c.toUpperCase()
            upperCase = false;
          } else {
            codeItemEnName = codeItemEnName + c;
          }
        }
        dict[i].codeItemEnName = codeItemEnName
      }
      if (this.isCusGroup === '10020001') {
        dict.push({codeItemCode: 'biz_salary_detail.CUS_ID', codeItemEnName: 'cusId', codeItemName: '客户名称'})
      }
      this.dimensionList = dict
      this.dimension = this.dimensionList[0].codeItemCode
    },
    getCostCenter() {
      api.getCostCenterList(this.cusId).then(res => {
        let costList = res.data.data
        if (costList.length > 0) {
          costList.forEach(cost => {
            let data = {'codeItemId': cost.id, 'codeItemName': cost.costName}
            this.costCenterList.push(data)
          })
        }
      })
    },
    saveCustomHeader() {
      if (this.$isEmpty(this.headerList)) {
        this.$msgError('显示项目不能为空')
        return
      }
      let param = {
        headers: this.headerList,
        reportType: '员工收入明细表'
      }
      this.submitLoading = true
      updataCustCostFormsHeaderInfo(param).then(res => {
        if (res.data.code === 0) {
          this.customHeaderModalShow = false
          this.$msgSuccess('保存成功')
          this._getCostFormsList()
          this._getimportHeader();
        }
      }).finally(() => this.submitLoading = false)
    },
    goBack() {
      this.$go()
    },
    //获取表头数据
    _getimportHeader: function () {
      this.checked = false;
      const that = this;
      costFormsListHeader({cusId: this.cusId, isMergeBill: this.isMergeBill, modeType: 'costForms'}).then(res => {
        let rs = res.data
        this.allColumn = rs.data
        debugger
        that.showColumn = this.filterIsShowHeaders(rs.data)
        that.showColumn.forEach(item => {
          // 补全 field
          if (!item.field) {
            item.field = item.field;
          }
          if (item.valueType === '2') {
            item.params = {
              amount: item.valueType === '2'
            }
          }
        })
        this._getCostFormsList();
      }).catch(() => {
      })
    },
    //获取列表数据
    _getCostFormsList() {
      this.loading = true;
      const that = this;
      let param = {
        'itemName': '成本中心',
        'billId': this.$route.query.billId,
        'cusId': this.cusId,
        'dimension': this.dimension,
        'isMergeBill': this.isMergeBill,
        'isCusGroup': this.isCusGroup,
        'modeType': 'costForms'
      }
      api.costFormsList(param).then(res => {
        this.loading = false;
        let data = res.data.data.map(el => {
          return {
            ...el,
          }
        })
        // this.bigDatas = JSON.parse(JSON.stringify(data))
        that.$set(that, "bigDatas", JSON.parse(JSON.stringify(data)))
      }).catch(() => {
        this.loading = false;
      })
    },

    // 过滤显示的表头
    filterIsShowHeaders: function (headerList) {
      debugger
      let arr = headerList.filter(element => element.show == true)
      let dimensionColumn = {
        columnCode: 'costCenter',
        title: '成本中心',
        width: 150,
        field: 'costCenter',
        show: true,
        fixed: 'left'
      }
     /* if (this.updateDimension) {
        arr.splice(1, 1, dimensionColumn)
      } else {
        arr.unshift(dimensionColumn)
        arr.unshift({type: 'seq', title: "序号", width: 50, show: true, fixed: 'left'})
      }*/
      arr.unshift({type: 'seq', title: "序号", width: 50, show: true, fixed: 'left'})
      return arr
    },
    // 表头分组
    splitColumns: function () {
      var that = this;
      // 按后台数据表将表头分类
      that.columnTables = {};
      that.showColumn.forEach(e => {
        if (e.tableName) {
          if (that.columnTables[e.tableName]) {
            that.columnTables[e.tableName].push(e.columnCode)
          } else {
            that.columnTables[e.tableName] = [];
            that.columnTables[e.tableName].push(e.columnCode)
          }
        }
      })
    },
    exportTable() {
      let expColumns = this.$refs.bigEdit.$refs.bigTable.getColumns().filter(item => !'seq,checkbox'.includes(item.type));
      if (expColumns.length > 255) {
        this.$message.error('导出的excel列头超过255个，无法导出！现在列头：' + expColumns.length);
        return;
      }
      expColumns.forEach(item => {
        item.field = item.property
      })
      let cusName = this.$route.query.cusName
      let fileName = '成本中心表.xls'
      if (cusName) {
        fileName = cusName + '-' + fileName
      }
      let param = {
        itemName: '成本中心',
        billId: this.$route.query.billId,
        cusId: this.cusId,
        dimension: this.dimension,
        isMergeBill: this.isMergeBill,
        isCusGroup: this.isCusGroup,
        modeType: 'costForms',
        columns: this.showColumn,
        fileName: fileName
      }
      api.exportCostFormsForHrCloud(param).then(res => {
        if (res.headers['content-disposition'] == undefined) {
          this.downLoad = false
          this.$message.error('账单下载失败,请联系运维人员！')
        } else {
          this.$downloadFile(res)
          this.downLoad = false
          this.$message.success("下载成功！");
        }
      })
    },
  }
};

</script>
